<template>
  <div class="field multiplexer-field" :style="field.style" v-if="condition && local_value">
    <label class="label" v-if="local_value.label">
      {{ local_value.label }}
      {{ local_value.required ? " *" : "" }}
    </label>
    <div class="multiplexer-list">
      <div class="multiplexer-type" v-for="f in (local_value.options || [])" :key="f.id">
        <div class="multiplexer-type-label">{{ f.label }}</div>
        <div class="multiplexer-type-values">
          <div
            class="multiplexer-row"
            v-for="c in rowsForType(f.id)"
            :key="rowKey(c)"
          >
            <div class="control has-icons-left multiplexer-input-wrap">
              <input
                class="input is-small"
                v-model="c.value"
                type="text"
                :placeholder="f.label + '...'"
                @input="sync"
              />
              <span class="icon is-small is-left">
                <i :class="f.icon"></i>
              </span>
            </div>
            <a
              href=""
              class="multiplexer-icon-btn multiplexer-icon-btn--danger"
              title="Hiq"
              @click.prevent="removeRow(c)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </div>
        <a
          href=""
          class="multiplexer-icon-btn multiplexer-icon-btn--add"
          title="Shto"
          @click.prevent="addRow(f.id)"
        >
          <i class="fa fa-plus"></i>
        </a>
      </div>
    </div>
    <p class="help is-danger" v-if="local_value.required && (!local_value.data || local_value.data.length == 0)">
      {{ local_value.required_text ? local_value.required_text : "Fushe e detyrueshme" }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["field", "fields"],
  data() {
    return {
      local_value: null,
      rowSeq: 0,
    };
  },
  computed: {
    condition() {
      var is_visible = true;
      if (!this.local_value) return false;
      if (this.local_value.vif) {
        if (this.fields)
          this.fields.map((f) => {
            if (f.length) {
              f.map((ff) => {
                this.local_value.vif.map((c) => {
                  if (ff.name == c.field) {
                    if (c.value_not !== undefined) is_visible = ff.value != c.value_not;
                  }
                });
              });
            } else {
              this.local_value.vif.map((c) => {
                if (f.name == c.field) {
                  if (c.value_not !== undefined) {
                    is_visible = f.value != c.value_not;
                  }
                  if (c.value !== undefined) {
                    is_visible = f.value == c.value;
                  }
                }
              });
            }
          });
      }
      return is_visible;
    },
  },
  methods: {
    ensureData() {
      if (!this.local_value.data || !Array.isArray(this.local_value.data)) {
        this.local_value.data = [];
      }
      this.local_value.data.forEach((row) => {
        if (!row._key) {
          this.rowSeq += 1;
          row._key = "cd-" + this.rowSeq;
        }
      });
    },
    rowsForType(typeId) {
      if (!this.local_value?.data) return [];
      return this.local_value.data.filter((t) => t.type_id == typeId);
    },
    rowKey(row) {
      return row._key || row.guid || row.id || String(row.type_id) + "-" + (row.value || "");
    },
    nextKey() {
      this.rowSeq += 1;
      return "cd-" + this.rowSeq;
    },
    addRow(typeId) {
      this.ensureData();
      this.local_value.data.push({
        guid: null,
        type_id: typeId,
        value: "",
        _key: this.nextKey(),
      });
      this.sync();
    },
    removeRow(row) {
      this.ensureData();
      const idx = this.local_value.data.indexOf(row);
      if (idx === -1) return;
      this.local_value.data.splice(idx, 1);
      this.sync();
    },
    sync() {
      this.$emit("syncField", this.local_value);
    },
  },
  watch: {
    field() {
      this.local_value = { ...(this.field || {}) };
      if (!Array.isArray(this.local_value.data)) this.local_value.data = [];
      this.ensureData();
    },
  },
  created() {
    this.local_value = { ...(this.field || {}) };
    if (!Array.isArray(this.local_value.data)) this.local_value.data = [];
    this.ensureData();
  },
};
</script>

<style scoped>
.label {
  margin-bottom: 8px !important;
  color: #334155;
}
.multiplexer-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.multiplexer-type {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr) 32px;
  gap: 8px 10px;
  align-items: start;
}
.multiplexer-type-label {
  padding-top: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  line-height: 1.3;
}
.multiplexer-type-values {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.multiplexer-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.multiplexer-input-wrap {
  flex: 1 1 auto;
  min-width: 0;
}
.multiplexer-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 8px;
  color: #64748b;
}
.multiplexer-icon-btn:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.multiplexer-icon-btn--danger {
  color: #b91c1c;
}
.multiplexer-icon-btn--danger:hover {
  background: #fef2f2;
  color: #991b1b;
}
.multiplexer-icon-btn--add {
  margin-top: 2px;
  color: #0f766e;
}
.multiplexer-icon-btn--add:hover {
  background: #f0fdfa;
  color: #0f766e;
}
@media (max-width: 640px) {
  .multiplexer-type {
    grid-template-columns: minmax(0, 1fr) 32px;
  }
  .multiplexer-type-label {
    grid-column: 1 / -1;
    padding-top: 0;
  }
}
</style>
